import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public loginEmitter = new EventEmitter<any>();
  private token: string;
  private userId: string;
  private tokenTime: string;

  constructor() {
    this.token = this.getToken();
    this.userId = this.getUserId();
    this.tokenTime = this.getTokenTime();
  }

  public getToken(): string {
    if (localStorage.getItem('id_token') != null) {
      return localStorage.getItem('id_token');
    }
    return null;
  }

  public setToken(token, id) {
    this.token = token;
    this.userId = id;
    localStorage.setItem('id_token', token);
    localStorage.setItem('id', id);
    localStorage.setItem('time', String(new Date()));
    this.loginEmitter.emit(true);
  }

  public IsLoggedIn(): boolean {
    if (localStorage.getItem('id_token') != null) {
      return true;
    }
    return false;
  }

  public getUserType() {
    if (localStorage.getItem('userType') != null) {
      return localStorage.getItem('userType');
    }
    return null;
  }

  public getUserId() {
    if (localStorage.getItem('id') != null) {
      return localStorage.getItem('id');
    }
    return null;
  }

  public getTokenTime() {
    if (localStorage.getItem('time') != null) {
      return localStorage.getItem('time');
    }
    return null;
  }

  resetTokens() {
    this.loginEmitter.emit(false);
    this.token = null;
    this.userId = null;
    this.tokenTime = null;
    localStorage.clear();
  }
}
